import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as artistsActions from '../../store/actions/artistsActions'
import { Container, Grid, GridCol } from '../common/Grid'
import { Panel } from '../common/Panel'
import { Artists } from '../Artists'
import './ArtistsView.css'

class ArtistsView extends React.Component {
    render() {
        return (
            <Container className="artists-view">
                <Panel title="Artisti">
                    <Grid>
                        <GridCol className="_left">
                            <Artists.AddForm {...this.props} />
                        </GridCol>
                        <GridCol className="_right">
                            <Artists.List {...this.props} />
                        </GridCol>
                    </Grid>
                </Panel>
            </Container>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        artists: state.artists.artists
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        artistsActions: bindActionCreators(artistsActions, dispatch)
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ArtistsView))


// WEBPACK FOOTER //
// ./src/components/views/ArtistsView.js